var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconControlBarExperiences = function SvgIconControlBarExperiences(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    }
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_control_bar_experiences_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.294 12.588a.834.834 0 0 1 .745 1.49l-6.666 3.334a.83.83 0 0 1-.746 0L2.961 14.08a.834.834 0 0 1 .745-1.491L10 15.734zm0-3.333a.834.834 0 0 1 .745 1.49l-6.666 3.334a.83.83 0 0 1-.746 0l-6.666-3.334a.833.833 0 0 1 .745-1.49L10 12.4zM9.81 2.523a.83.83 0 0 1 .563.065l6.666 3.333a.833.833 0 0 1 0 1.491l-6.666 3.333a.83.83 0 0 1-.746 0L2.961 7.412a.833.833 0 0 1 0-1.49l6.666-3.334zM5.197 6.667 10 9.067l4.803-2.4L10 4.264z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_control_bar_experiences_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgIconControlBarExperiences;